// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ProjectSvg from '@rsuite/icon-font/lib/file/Project';
var Project = createSvgIcon({
  as: ProjectSvg,
  ariaLabel: 'project',
  category: 'file',
  displayName: 'Project'
});
export default Project;